import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
  DeleteRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type DeleteAssessmentSkillScoreImportArgsType = DeleteRequestArgsType & {
  assessmentSkillScoreImportId: number;
};

export const apiFetchAssessmentSkillScoreImports = async ({
  domain = useTenantStore().domain,
  query = {},
  errorConfig = {},
  callbacks = {},
}: GetRequestArgsType = {}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.assessmentSkillScoreImports({ domain }),
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiDeleteAssessmentSkillScoreImport = async ({
  domain = useTenantStore().domain,
  assessmentSkillScoreImportId,
  errorConfig = {},
  callbacks = {},
}: DeleteAssessmentSkillScoreImportArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.delete({
      url: urls.v1.assessmentSkillScoreImports({
        domain,
        assessmentSkillScoreImportId,
      }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
